import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from '../../lib'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doPROFILE_SET} from '../state'
import {getToken} from './token_fetcher'

export const REQUEST_PROFILE_UPDATE = 'REQUEST_PROFILE_UPDATE'
export const doREQUEST_PROFILE_UPDATE = createDoRequestAction(REQUEST_PROFILE_UPDATE)

export const requestProfileUpdateActionCreators = {
  doREQUEST_PROFILE_UPDATE,
}

export function* requestProfileUpdate({payload, setRequestResult}: any): SagaIterator {
  debug('saga*profileUpdate')
  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        lastName: v.string().exist(),
        firstName: v.string().exist(),
        title: v.string().allow('').optional(),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROFILE_UPDATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const {lastName, firstName, title} = payload

  const accessToken = yield call(getToken)

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/profile-update`,
    accessToken,
    data: {
      lastName,
      firstName,
      title,
    },
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_PROFILE_UPDATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/profile-update',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doPROFILE_SET(result.payload))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_PROFILE_UPDATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* profileUpdateSaga() {
  yield takeEvery(REQUEST_PROFILE_UPDATE, requestProfileUpdate)
}
